module.exports = __webpack_public_path__ + "img/Spotify_Logo_RGB_White.31bad8d4.png";